import { render, staticRenderFns } from "./TheHeaderHelp.vue?vue&type=template&id=e4e21910&scoped=true"
import script from "./TheHeaderHelp.vue?vue&type=script&lang=js"
export * from "./TheHeaderHelp.vue?vue&type=script&lang=js"
import style0 from "./TheHeaderHelp.vue?vue&type=style&index=0&id=e4e21910&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4e21910",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4e21910')) {
      api.createRecord('e4e21910', component.options)
    } else {
      api.reload('e4e21910', component.options)
    }
    module.hot.accept("./TheHeaderHelp.vue?vue&type=template&id=e4e21910&scoped=true", function () {
      api.rerender('e4e21910', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/control/components/TheHeaderHelp.vue"
export default component.exports